import MainModal from "../../ui/MainModal";
import { useModal } from "../../../hooks/useModal";
import { Button, FormLabel, Grid, Stack, Typography } from "@mui/material";
import { StyledInput } from "../../ui/StyledInput";
import { ChangeEvent, useEffect, useState } from "react";
import { postShipmentProfilesApi } from "./setupApi";
import toast from "react-hot-toast";
import { useSync } from "./ShipmentProfiles";
import { Close } from "@mui/icons-material";
import { StyledButton } from "../../ui/StyledButton";

export interface ProfileShipmentData {
  order_channel: string;
  product_name: string;
  description: string;
  length: number;
  width: number;
  height: number;
  weight: number;
  hsn_code: string;

  [key: string]: string | number;
}

const AddProfileModal = () => {
  const { isOpen, type, onClose, data } = useModal();

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [width, setWidth] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (windowWidth < 768) {
      setWidth(false);
    } else {
      setWidth(true);
    }
  }, [windowWidth]);

  const [isValid, setIsValid] = useState(false);

  const defaultData: ProfileShipmentData = {
    order_channel: "Channel",
    product_name: "",
    description: "",
    length: 0,
    width: 0,
    height: 0,
    weight: 0,
    hsn_code: "",
  };

  const [formData, setFormData] = useState<ProfileShipmentData>(defaultData);

  const open = isOpen && type === "profile";

  const { setSync } = useSync();

  const validateForm = () => {
    let isValid = false;
    if (
      formData.description.trim() !== "" &&
      formData.hsn_code.trim() !== "" &&
      formData.product_name.trim() !== "" &&
      formData.order_channel.trim() !== "" &&
      formData.height !== 0 &&
      formData.length !== 0 &&
      formData.weight !== 0 &&
      formData.height !== 0
    ) {
      isValid = true;
    }

    setIsValid(isValid);
  };

  const handleInputChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    field: keyof ProfileShipmentData
  ) => {
    const newFormData = { ...formData };
    newFormData[field] = e.target.value;
    setFormData(newFormData);
  };

  useEffect(() => {
    validateForm();
  }, [formData]);

  const onSubmit = () => {
    postShipmentProfilesApi(formData)
      .then((data) => {
        console.log(data);
        toast.success("Shipment Profile Created Successfully");
        setFormData(defaultData);
        setSync();
        onClose();
      })
      .catch(() => toast.error("Unable to create shipment profile"));
  };

  return (
    <MainModal
      open={open}
      handleClose={onClose}
      width={width ? "800px" : "100%"}
    >
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Stack
            flexDirection={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Typography>Profile Details</Typography>
            <Button onClick={onClose}>
              <Close />
            </Button>
          </Stack>
        </Grid>
        <Grid item xs={6} sm={6} md={6}>
          <FormLabel>
            <Typography fontSize={12}>Order Channel</Typography>
          </FormLabel>
          <StyledInput
            value={formData.order_channel}
            placeholder="Order Channel"
            fullWidth
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6}>
          <FormLabel>
            <Typography fontSize={12}>Product Name</Typography>
          </FormLabel>
          <StyledInput
            value={formData.product_name}
            onChange={(e) => handleInputChange(e, "product_name")}
            placeholder="Product Name"
            fullWidth
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6}>
          <FormLabel>
            <Typography fontSize={12}>Description</Typography>
          </FormLabel>
          <StyledInput
            value={formData.description}
            onChange={(e) => handleInputChange(e, "description")}
            placeholder="Description"
            fullWidth
          />
        </Grid>
        <Grid item xs={6} sm={2} md={2}>
          <FormLabel>
            <Typography fontSize={12}>Length</Typography>
          </FormLabel>
          <StyledInput
            value={formData.length}
            onChange={(e) => handleInputChange(e, "length")}
            placeholder="length"
            fullWidth
          />
        </Grid>
        <Grid item xs={6} sm={2} md={2}>
          <FormLabel>
            <Typography fontSize={12}>Width</Typography>
          </FormLabel>
          <StyledInput
            value={formData.width}
            onChange={(e) => handleInputChange(e, "width")}
            placeholder="Width"
            fullWidth
          />
        </Grid>
        <Grid item xs={6} sm={2} md={2}>
          <FormLabel>
            <Typography fontSize={12}>Height</Typography>
          </FormLabel>
          <StyledInput
            value={formData.height}
            onChange={(e) => handleInputChange(e, "height")}
            placeholder="Height"
            fullWidth
          />
        </Grid>
        <Grid item xs={6}>
          <FormLabel>
            <Typography fontSize={12}>Weight</Typography>
          </FormLabel>
          <StyledInput
            value={formData.weight}
            onChange={(e) => handleInputChange(e, "weight")}
            placeholder="Weight"
            fullWidth
          />
        </Grid>
        <Grid item xs={6}>
          <FormLabel>
            <Typography fontSize={12}>HSN Code</Typography>
          </FormLabel>
          <StyledInput
            value={formData.hsn_code}
            onChange={(e) => handleInputChange(e, "hsn_code")}
            placeholder="HSN Code"
            fullWidth
          />
        </Grid>
        <Grid item xs={12}>
          <StyledButton
            disabled={!isValid}
            variant="contained"
            onClick={onSubmit}
          >
            Submit
          </StyledButton>
        </Grid>
      </Grid>
    </MainModal>
  );
};

export default AddProfileModal;
